import React from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material/";
import { OpenInNew as OpenInNewIcon } from "@mui/icons-material";
import { Document, Page } from "react-pdf";
import { useTheme } from "@mui/material/styles";
import { strings } from "../../../../common/i18n";
import "../../../../common/js/pdf.worker.min.js";
import styles from "./styles";

const PdfViewer = ({ path, pageWidth, numPages, setNumPages, pdfKey }) => {
    const theme = useTheme();
    const onDocumentLoadSuccess = ({ numPages }) => setNumPages(numPages);

    const openPdfInNewWindow = (pdfUrl) => {
        const width = 1200,
            height = 800;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;

        const googleViewer = `https://docs.google.com/viewer?url=${encodeURIComponent(
            pdfUrl
        )}&embedded=true`;

        window.open(
            googleViewer,
            "_blank",
            `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
        );
    };

    return (
        <Box sx={styles(theme).pdfViewContainer} key={`${pdfKey}-`}>
            <Box sx={styles(theme).pdfIconContainer}>
                <Tooltip title="Open in new tab">
                    <IconButton
                        onClick={() => openPdfInNewWindow(path)}
                        aria-label="open"
                        sx={styles(theme).openNewTab}
                    >
                        <OpenInNewIcon />
                    </IconButton>
                </Tooltip>
            </Box>
            <Document
                key={`${pdfKey}-document`}
                file={path}
                onLoadSuccess={onDocumentLoadSuccess}
                loading={
                    <Typography variant="caption" sx={styles(theme).pdfLoading}>
                        {strings("loadingPdf")}
                    </Typography>
                }
                error={
                    <Typography
                        variant="caption"
                        sx={styles(theme).pdfViewerError}
                    >
                        {strings("failedToLoadPdf")}
                    </Typography>
                }
            >
                {numPages &&
                    Array.from(new Array(numPages), (_, pageIndex) => (
                        <Page
                            key={`${pdfKey}-page-${pageIndex}`}
                            pageNumber={pageIndex + 1}
                            renderTextLayer={false}
                            renderAnnotationLayer={false}
                            width={pageWidth}
                        />
                    ))}
            </Document>
        </Box>
    );
};

export default PdfViewer;
